var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5206_22893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.275 78.1723L89.501 159.876L7.69241 78.1373C6.85334 77.2982 5.69963 76.8088 4.51096 76.8088C0.595335 76.7738 -1.53728 81.6683 1.32951 84.5002L86.3545 169.455C88.1026 171.203 90.9694 171.203 92.7174 169.455L177.672 84.5701C181.693 80.2 175.715 74.0818 171.275 78.1723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3195 100.898C88.0676 102.646 90.9344 102.646 92.6824 100.898L177.638 16.0125C179.421 14.2644 179.421 11.3976 177.638 9.6146C175.854 7.83159 173.023 7.83159 171.24 9.6146L89.501 91.3183L7.69238 9.54468C5.83945 7.90151 3.00762 8.04136 1.32949 9.89429C-0.208789 11.6074 -0.208789 14.2294 1.32949 15.9425L86.3195 100.898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5206_22893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 179,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.c819705b7eadd2cd7cfc849086831006.svg";
export { ForwardRef as ReactComponent };